export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGOUT = 'LOGOUT';

export const SET_CYCLE = 'SET_CYCLE';
export const INCREMENT_CYCLE = 'INCREMENT_CYCLE';
export const DECREMENT_CYCLE = 'DECREMENT_CYCLE';

export const ADD_FILTER = 'ADD_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const REMOVE_ALL_FILTERS = 'REMOVE_ALL_FILTERS';

export const GET_ALL_CARRIERS_SUBS_WITHOUT_LAYOVER =
  'GET_ALL_CARRIERS_SUBS_WITHOUT_LAYOVER';
export const GET_ALL_USER_SUBS = 'GET_ALL_USER_SUBS';
